import React, { useEffect, useState } from 'react';

interface ErrorToastProps {
  message?: string;
  onDismiss: () => void;
}

const ErrorToast: React.FC<ErrorToastProps> = ({
  message = 'Something went wrong. A support ticket has been created.',
  onDismiss,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDismiss, 300);
    }, 5000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        background: '#c62828',
        color: '#fff',
        padding: '14px 20px',
        borderRadius: 8,
        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
        fontSize: 14,
        fontWeight: 500,
        zIndex: 10000,
        maxWidth: 360,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s, transform 0.3s',
        cursor: 'pointer',
      }}
      onClick={() => { setVisible(false); setTimeout(onDismiss, 300); }}
    >
      {message}
    </div>
  );
};

export default ErrorToast;
